import React, { useState } from 'react';
import AnimatedText from '../ui/AnimatedText';
import RevealSection from '../ui/RevealSection';

export default function Contact() {
  const categories = ['Inteligencia Artificial', 'Logística', 'Energía', 'Seguridad Ciberfísica'];
  const [formData, setFormData] = useState({ name: '', email: '', categories: [], message: '' });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  return (
    <section id="contact" className="section py-32">
      <div className="max-w-4xl mx-auto w-full text-center">
        <RevealSection>
          <p className="text-white/40 text-sm font-body font-extralight uppercase tracking-[0.3em] mb-6">
            Contacto
          </p>
        </RevealSection>
        <RevealSection delay={0.1}>
          <h2 className="font-display font-medium text-4xl sm:text-5xl md:text-6xl tracking-tight mb-16">
            Hablemos.
          </h2>
        </RevealSection>

        {/* Form */}
        <RevealSection delay={0.3} direction="scale">
          <form
            onSubmit={handleSubmit}
            className="max-w-lg mx-auto space-y-4 text-left"
          >
            <div>
              <label htmlFor="contact-name" className="sr-only">Nombre</label>
              <input
                id="contact-name"
                type="text"
                name="name"
                placeholder="Nombre"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-white/[0.03] border border-white/10 rounded-lg text-white font-body font-extralight placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors text-sm"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="sr-only">Email</label>
              <input
                id="contact-email"
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 bg-white/[0.03] border border-white/10 rounded-lg text-white font-body font-extralight placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors text-sm"
              />
            </div>
            <div className="flex flex-wrap gap-2">
              {categories.map((cat) => (
                <button
                  key={cat}
                  type="button"
                  onClick={() => setFormData((prev) => ({
                    ...prev,
                    categories: prev.categories.includes(cat)
                      ? prev.categories.filter((c) => c !== cat)
                      : [...prev.categories, cat],
                  }))}
                  className={`px-4 py-2 rounded-full text-sm font-body font-extralight border transition-all duration-300 ${
                    formData.categories.includes(cat)
                      ? 'bg-white text-black border-white'
                      : 'bg-transparent text-white/30 border-white/10 hover:border-white/25 hover:text-white/50'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>
            <div>
              <label htmlFor="contact-message" className="sr-only">Mensaje</label>
              <textarea
                id="contact-message"
                name="message"
                placeholder="Cuéntanos sobre tu proyecto"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                required
                className="w-full px-4 py-3 bg-white/[0.03] border border-white/10 rounded-lg text-white font-body font-extralight placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors text-sm resize-none"
              />
            </div>
            <button
              type="submit"
              className="w-full py-3 rounded-lg bg-white text-black font-display font-medium text-sm hover:bg-white/90 transition-all"
            >
              Enviar
            </button>
          </form>
        </RevealSection>

        {/* Footer */}
        <RevealSection delay={0.5}>
          <div className="mt-20 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <span className="font-display font-medium text-sm tracking-[0.1em]">EURISTIK</span>
            </div>
            <p className="text-white/20 font-body font-extralight text-xs">
              &copy; {new Date().getFullYear()} Euristik&reg;. Todos los derechos reservados.
            </p>
          </div>
        </RevealSection>
      </div>
    </section>
  );
}
